export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-movie-2-line', description: '最新热门电影推荐' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-2-line', description: '热门电视剧全集' },
  { slug: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line', description: '热门综艺节目' },
  { slug: 'anime', name: '动漫', icon: 'ri-rocket-line', description: '精选动漫番剧' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line', description: '高分纪录片推荐' },
  { slug: 'shorts', name: '短视频', icon: 'ri-vidicon-line', description: '精彩短视频合集' },
];

export const featuredVideos = [
  {
    id: 'v1',
    title: '流浪地球3',
    category: 'movie',
    categoryName: '电影',
    rating: 9.2,
    views: '1280万',
    duration: '2h 28min',
    description: '太阳急速老化，持续膨胀。流浪地球时代的年轻人挺身而出，展开争分夺秒的生死之战。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20sci-fi%20film%20scene%20with%20dramatic%20golden%20and%20deep%20red%20tones%2C%20epic%20space%20movie%20poster%20aesthetic%2C%20professional%20cinematography%20style%2C%20rich%20atmospheric%20mood%2C%20theatrical%20composition%20with%20soft%20bokeh%20background%2C%20high%20production%20value%20look&width=1800&height=1000&seq=tangxin-hero-01&orientation=landscape',
    year: 2026,
  },
  {
    id: 'v2',
    title: '庆余年 第二季',
    category: 'tv',
    categoryName: '电视剧',
    rating: 9.5,
    views: '3580万',
    duration: '36集',
    description: '范闲经历生死考验后回归南庆，面对更加复杂的朝堂斗争与江湖恩怨。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20scene%20with%20warm%20golden%20ambient%20lighting%2C%20ancient%20palace%20aesthetic%2C%20professional%20cinematography%20style%2C%20rich%20atmospheric%20mood%2C%20theatrical%20composition%20with%20elegant%20color%20palette%2C%20high%20production%20value&width=1800&height=1000&seq=tangxin-hero-02&orientation=landscape',
    year: 2026,
  },
  {
    id: 'v3',
    title: '乘风破浪的姐姐 第五季',
    category: 'variety',
    categoryName: '综艺',
    rating: 8.9,
    views: '2100万',
    duration: '12期',
    description: '三十位30+姐姐重新出发，用舞台证明实力与魅力，展现女性力量。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20performance%20scene%20with%20vibrant%20lighting%20and%20warm%20tones%2C%20entertainment%20show%20aesthetic%2C%20professional%20stage%20lighting%20design%2C%20dramatic%20atmospheric%20mood%2C%20colorful%20composition%20with%20soft%20bokeh&width=1800&height=1000&seq=tangxin-hero-03&orientation=landscape',
    year: 2026,
  },
  {
    id: 'v4',
    title: '斗破苍穹 年番',
    category: 'anime',
    categoryName: '动漫',
    rating: 9.3,
    views: '5600万',
    duration: '52集',
    description: '萧炎踏上修炼之路，为了变强不断挑战极限，在斗气大陆上书写传奇。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20fantasy%20scene%20with%20dramatic%20warm%20golden%20and%20fire%20orange%20tones%2C%20epic%20animation%20poster%20aesthetic%2C%20professional%20illustration%20style%2C%20rich%20atmospheric%20mood%2C%20theatrical%20composition%20with%20dynamic%20energy&width=1800&height=1000&seq=tangxin-hero-04&orientation=landscape',
    year: 2026,
  },
];

export const trendingVideos = [
  {
    id: 't1',
    title: '狂飙',
    category: 'tv',
    categoryName: '电视剧',
    rating: 9.6,
    views: '8920万',
    duration: '39集',
    description: '以一线刑警安欣为代表的正义力量与黑恶势力展开的长达二十年的生死较量。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20crime%20drama%20poster%20style%20with%20dramatic%20warm%20lighting%2C%20professional%20movie%20poster%20aesthetic%2C%20rich%20dark%20tones%20and%20dramatic%20composition%2C%20soft%20background%20texture%2C%20high%20quality%20film%20photography&width=600&height=800&seq=tangxin-trend-01&orientation=portrait',
    year: 2023,
  },
  {
    id: 't2',
    title: '孤注一掷',
    category: 'movie',
    categoryName: '电影',
    rating: 9.0,
    views: '4500万',
    duration: '2h 10min',
    description: '程序员潘生与模特安娜被海外高薪招聘吸引，却意外卷入境外诈骗工厂的陷阱。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20thriller%20film%20poster%20style%20with%20intense%20warm%20lighting%2C%20professional%20movie%20poster%20aesthetic%2C%20rich%20red%20and%20gold%20tones%20dramatic%20composition%2C%20high%20quality%20film%20photography&width=600&height=800&seq=tangxin-trend-02&orientation=portrait',
    year: 2023,
  },
  {
    id: 't3',
    title: '繁花',
    category: 'tv',
    categoryName: '电视剧',
    rating: 9.3,
    views: '6800万',
    duration: '30集',
    description: '九十年代的上海，阿宝凭借时代机遇和个人努力成为商界后起之秀。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20period%20drama%20poster%20style%20with%20nostalgic%20warm%20golden%20lighting%2C%20professional%20movie%20poster%20aesthetic%2C%20rich%20elegant%20tones%20and%20classic%20composition&width=600&height=800&seq=tangxin-trend-03&orientation=portrait',
    year: 2024,
  },
  {
    id: 't4',
    title: '封神第一部',
    category: 'movie',
    categoryName: '电影',
    rating: 8.8,
    views: '3200万',
    duration: '2h 28min',
    description: '商王殷寿与狐妖妲己勾结暴虐无道，引发天谴。昆仑仙人姜子牙携封神榜下山。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20mythological%20film%20poster%20style%20with%20epic%20warm%20golden%20lighting%2C%20professional%20movie%20poster%20aesthetic%2C%20rich%20dramatic%20tones%20and%20mythical%20composition&width=600&height=800&seq=tangxin-trend-04&orientation=portrait',
    year: 2023,
  },
  {
    id: 't5',
    title: '三体',
    category: 'tv',
    categoryName: '电视剧',
    rating: 8.7,
    views: '5100万',
    duration: '30集',
    description: '纳米科学家汪淼被卷入神秘事件，逐渐发现地外文明三体世界的存在。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20sci-fi%20drama%20poster%20style%20with%20mysterious%20warm%20lighting%2C%20professional%20movie%20poster%20aesthetic%2C%20rich%20cosmic%20tones%20and%20futuristic%20composition&width=600&height=800&seq=tangxin-trend-05&orientation=portrait',
    year: 2023,
  },
  {
    id: 't6',
    title: '熊出没·逆转时空',
    category: 'movie',
    categoryName: '电影',
    rating: 8.5,
    views: '2800万',
    duration: '1h 39min',
    description: '光头强穿越时空回到过去，试图改变命运，却引发了一系列意想不到的连锁反应。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20animation%20film%20poster%20style%20with%20colorful%20warm%20lighting%2C%20professional%20animated%20movie%20poster%20aesthetic%2C%20rich%20playful%20tones%20and%20dynamic%20composition&width=600&height=800&seq=tangxin-trend-06&orientation=portrait',
    year: 2024,
  },
  {
    id: 't7',
    title: '奔跑吧 第十二季',
    category: 'variety',
    categoryName: '综艺',
    rating: 8.3,
    views: '1900万',
    duration: '12期',
    description: '全新阵容开启奔跑之旅，在欢笑与挑战中展现团队精神与个人魅力。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20variety%20show%20poster%20style%20with%20vibrant%20warm%20lighting%2C%20professional%20entertainment%20poster%20aesthetic%2C%20rich%20colorful%20tones%20and%20energetic%20composition&width=600&height=800&seq=tangxin-trend-07&orientation=portrait',
    year: 2026,
  },
  {
    id: 't8',
    title: '完美世界',
    category: 'anime',
    categoryName: '动漫',
    rating: 9.1,
    views: '4200万',
    duration: '78集',
    description: '少年石昊在蛮荒世界中一步步成长，踏上寻找完美世界的征途。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20anime%20poster%20style%20with%20epic%20warm%20lighting%2C%20professional%20animation%20poster%20aesthetic%2C%20rich%20fantasy%20tones%20and%20heroic%20composition&width=600&height=800&seq=tangxin-trend-08&orientation=portrait',
    year: 2026,
  },
];

export const articles = [
  {
    id: 'a1',
    title: '2026年最值得期待的十大国产电影',
    excerpt: '从科幻巨制到现实主义佳作，2026年的国产电影市场精彩纷呈。本文为你盘点今年不容错过的十部电影作品。',
    category: 'movie',
    categoryName: '电影资讯',
    date: '2026-07-28',
    author: '影视编辑小王',
    views: '3.2万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20film%20and%20television%20scene%20with%20warm%20cinematic%20lighting%2C%20editorial%20photography%20style%2C%20professional%20composition%20with%20soft%20focus%2C%20rich%20atmospheric%20tones%2C%20movie%20theater%20atmosphere&width=800&height=450&seq=tangxin-article-01&orientation=landscape',
  },
  {
    id: 'a2',
    title: '古装剧为何能持续霸屏？深度解析古装剧的魅力密码',
    excerpt: '从服化道到剧本创作，从演员选角到导演风格，古装剧为何能在中国电视剧市场中始终占据重要地位？',
    category: 'tv',
    categoryName: '剧评分析',
    date: '2026-07-25',
    author: '资深剧评人李明',
    views: '2.8万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20scene%20with%20warm%20golden%20cinematic%20lighting%2C%20editorial%20photography%20style%2C%20professional%20composition%20with%20soft%20focus%2C%20elegant%20atmospheric%20tones&width=800&height=450&seq=tangxin-article-02&orientation=landscape',
  },
  {
    id: 'a3',
    title: '国漫崛起：从《哪吒》到《深海》，中国动画的十年蜕变',
    excerpt: '回顾过去十年中国动画电影的发展历程，从技术突破到故事创新，国漫正在走向世界舞台中央。',
    category: 'anime',
    categoryName: '动漫观察',
    date: '2026-07-22',
    author: '动漫评论员张华',
    views: '4.1万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20film%20scene%20with%20colorful%20warm%20cinematic%20lighting%2C%20editorial%20photography%20style%2C%20professional%20composition%20with%20soft%20focus%2C%20vibrant%20fantasy%20atmospheric%20tones&width=800&height=450&seq=tangxin-article-03&orientation=landscape',
  },
  {
    id: 'a4',
    title: '综艺节目的创新之路：从棚内录制到户外真人秀',
    excerpt: '中国综艺节目经历了怎样的变革？本文带你回顾综艺节目的发展历程，探讨未来的创新方向。',
    category: 'variety',
    categoryName: '综艺趋势',
    date: '2026-07-20',
    author: '综艺观察员陈思',
    views: '1.9万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20scene%20with%20vibrant%20warm%20cinematic%20lighting%2C%20editorial%20photography%20style%2C%20professional%20composition%20with%20soft%20focus%2C%20colorful%20entertainment%20atmosphere&width=800&height=450&seq=tangxin-article-04&orientation=landscape',
  },
  {
    id: 'a5',
    title: '纪录片推荐：五部让你重新认识世界的宝藏纪录片',
    excerpt: '从自然奇观到人文历史，这五部高分纪录片将带你领略世界的多样性与人类的智慧。',
    category: 'documentary',
    categoryName: '纪录推荐',
    date: '2026-07-18',
    author: '纪录片爱好者刘洋',
    views: '2.5万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20scene%20with%20warm%20natural%20cinematic%20lighting%2C%20editorial%20photography%20style%2C%20professional%20composition%20with%20soft%20focus%2C%20rich%20earth%20tones%20atmospheric%20mood&width=800&height=450&seq=tangxin-article-05&orientation=landscape',
  },
  {
    id: 'a6',
    title: '免费观影平台大比拼：糖心视频为何成为用户首选？',
    excerpt: '在众多免费视频平台中，糖心视频凭借高清不缓冲、内容丰富的优势脱颖而出，成为用户追剧首选。',
    category: 'movie',
    categoryName: '平台资讯',
    date: '2026-07-15',
    author: '科技博主赵明',
    views: '5.6万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20video%20streaming%20platform%20interface%20with%20warm%20cinematic%20lighting%2C%20editorial%20photography%20style%2C%20professional%20composition%20with%20soft%20focus%2C%20rich%20tech%20atmospheric%20tones&width=800&height=450&seq=tangxin-article-06&orientation=landscape',
  },
];

export const categoryVideos: Record<string, { id: string; title: string; rating: number; views: string; imageUrl: string }[]> = {
  movie: [
    { id: 'cm1', title: '热辣滚烫', rating: 8.9, views: '5200万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20comedy%20film%20scene%20dramatic%20warm%20lighting%20professional%20movie%20poster%20aesthetic%20rich%20atmospheric%20mood%20clean%20cinematic%20composition&width=800&height=450&seq=tangxin-cat-m-01&orientation=landscape' },
    { id: 'cm2', title: '消失的她', rating: 9.1, views: '6700万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20mystery%20film%20scene%20dramatic%20warm%20lighting%20professional%20movie%20poster%20aesthetic%20rich%20suspenseful%20mood%20clean%20cinematic%20composition&width=800&height=450&seq=tangxin-cat-m-02&orientation=landscape' },
    { id: 'cm3', title: '满江红', rating: 8.7, views: '4800万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20historical%20film%20scene%20dramatic%20warm%20lighting%20professional%20movie%20poster%20aesthetic%20rich%20atmospheric%20mood%20clean%20cinematic%20composition&width=800&height=450&seq=tangxin-cat-m-03&orientation=landscape' },
    { id: 'cm4', title: '长安三万里', rating: 9.0, views: '3900万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20animated%20film%20scene%20dramatic%20warm%20lighting%20professional%20movie%20poster%20aesthetic%20rich%20poetic%20mood%20clean%20cinematic%20composition&width=800&height=450&seq=tangxin-cat-m-04&orientation=landscape' },
  ],
  tv: [
    { id: 'ct1', title: '庆余年 第二季', rating: 9.5, views: '8100万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20costume%20drama%20scene%20dramatic%20warm%20lighting%20professional%20tv%20poster%20aesthetic%20rich%20atmospheric%20mood%20clean%20cinematic%20composition&width=800&height=450&seq=tangxin-cat-t-01&orientation=landscape' },
    { id: 'ct2', title: '长相思', rating: 9.2, views: '7300万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20romance%20drama%20scene%20dramatic%20warm%20lighting%20professional%20tv%20poster%20aesthetic%20rich%20emotional%20mood%20clean%20cinematic%20composition&width=800&height=450&seq=tangxin-cat-t-02&orientation=landscape' },
    { id: 'ct3', title: '莲花楼', rating: 9.3, views: '6500万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20martial%20arts%20drama%20scene%20dramatic%20warm%20lighting%20professional%20tv%20poster%20aesthetic%20rich%20atmospheric%20mood%20clean%20cinematic%20composition&width=800&height=450&seq=tangxin-cat-t-03&orientation=landscape' },
    { id: 'ct4', title: '长风渡', rating: 8.8, views: '5800万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20period%20drama%20scene%20dramatic%20warm%20lighting%20professional%20tv%20poster%20aesthetic%20rich%20atmospheric%20mood%20clean%20cinematic%20composition&width=800&height=450&seq=tangxin-cat-t-04&orientation=landscape' },
  ],
  variety: [
    { id: 'cv1', title: '奔跑吧 第十二季', rating: 8.5, views: '3100万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20variety%20show%20scene%20vibrant%20warm%20lighting%20professional%20entertainment%20poster%20aesthetic%20rich%20colorful%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-v-01&orientation=landscape' },
    { id: 'cv2', title: '歌手 2026', rating: 8.9, views: '4500万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20music%20show%20scene%20dramatic%20warm%20stage%20lighting%20professional%20entertainment%20poster%20aesthetic%20rich%20atmospheric%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-v-02&orientation=landscape' },
    { id: 'cv3', title: '王牌对王牌', rating: 8.3, views: '2800万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20game%20show%20scene%20vibrant%20warm%20lighting%20professional%20entertainment%20poster%20aesthetic%20rich%20playful%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-v-03&orientation=landscape' },
    { id: 'cv4', title: '向往的生活', rating: 9.0, views: '3600万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20lifestyle%20show%20scene%20natural%20warm%20lighting%20professional%20entertainment%20poster%20aesthetic%20rich%20peaceful%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-v-04&orientation=landscape' },
  ],
  anime: [
    { id: 'ca1', title: '斗罗大陆', rating: 9.2, views: '8900万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20anime%20fantasy%20scene%20dramatic%20warm%20lighting%20professional%20animation%20poster%20aesthetic%20rich%20adventurous%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-a-01&orientation=landscape' },
    { id: 'ca2', title: '完美世界', rating: 9.1, views: '7600万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20anime%20fantasy%20scene%20epic%20warm%20lighting%20professional%20animation%20poster%20aesthetic%20rich%20heroic%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-a-02&orientation=landscape' },
    { id: 'ca3', title: '凡人修仙传', rating: 9.4, views: '6200万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20anime%20cultivation%20scene%20dramatic%20warm%20lighting%20professional%20animation%20poster%20aesthetic%20rich%20mystical%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-a-03&orientation=landscape' },
    { id: 'ca4', title: '仙逆', rating: 9.3, views: '5400万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20anime%20fantasy%20scene%20epic%20warm%20lighting%20professional%20animation%20poster%20aesthetic%20rich%20dramatic%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-a-04&orientation=landscape' },
  ],
  documentary: [
    { id: 'cd1', title: '地球脉动 第三季', rating: 9.8, views: '1800万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20nature%20documentary%20scene%20natural%20warm%20lighting%20professional%20wildlife%20poster%20aesthetic%20rich%20earth%20tones%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-d-01&orientation=landscape' },
    { id: 'cd2', title: '河西走廊', rating: 9.7, views: '1500万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20history%20documentary%20scene%20natural%20warm%20lighting%20professional%20landscape%20poster%20aesthetic%20rich%20cultural%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-d-02&orientation=landscape' },
    { id: 'cd3', title: '舌尖上的中国', rating: 9.5, views: '2100万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20food%20documentary%20scene%20warm%20natural%20lighting%20professional%20culinary%20poster%20aesthetic%20rich%20appetizing%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-d-03&orientation=landscape' },
    { id: 'cd4', title: '航拍中国', rating: 9.6, views: '1700万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20aerial%20China%20documentary%20scene%20natural%20warm%20lighting%20professional%20landscape%20poster%20aesthetic%20rich%20scenic%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-d-04&orientation=landscape' },
  ],
  shorts: [
    { id: 'cs1', title: '搞笑短视频合集', rating: 8.6, views: '3500万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20funny%20short%20video%20scene%20vibrant%20warm%20lighting%20professional%20entertainment%20poster%20aesthetic%20rich%20playful%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-s-01&orientation=landscape' },
    { id: 'cs2', title: '美食探店精选', rating: 8.8, views: '2800万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20food%20vlog%20scene%20warm%20natural%20lighting%20professional%20culinary%20poster%20aesthetic%20rich%20appetizing%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-s-02&orientation=landscape' },
    { id: 'cs3', title: '旅行Vlog', rating: 8.7, views: '2200万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20travel%20vlog%20scene%20natural%20warm%20lighting%20professional%20adventure%20poster%20aesthetic%20rich%20scenic%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-s-03&orientation=landscape' },
    { id: 'cs4', title: '知识科普短片', rating: 9.0, views: '1900万', imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20educational%20science%20video%20scene%20warm%20professional%20lighting%20knowledge%20poster%20aesthetic%20rich%20informative%20mood%20clean%20composition&width=800&height=450&seq=tangxin-cat-s-04&orientation=landscape' },
  ],
};

export const stats = [
  { value: '5000万+', label: '月活跃用户', icon: 'ri-user-line' },
  { value: '10万+', label: '影视资源', icon: 'ri-film-line' },
  { value: '99.9%', label: '播放成功率', icon: 'ri-check-double-line' },
  { value: '4.9', label: '用户评分', icon: 'ri-star-line' },
];

export const aboutInfo = {
  brandName: '糖心视频',
  tagline: '让每个人都能享受高清观影的乐趣',
  introduction: '糖心视频成立于2020年，是国内领先的免费在线影视平台。我们致力于为用户提供丰富、高清、流畅的观影体验，涵盖电影、电视剧、综艺、动漫、纪录片等多种类型内容。经过多年的发展，糖心视频已成为超过5000万用户信赖的追剧首选平台。',
  mission: '我们的使命是让优质影视内容触手可及，无论用户身处何地，都能享受极致的观影体验。',
  values: [
    { title: '用户至上', description: '一切以用户体验为核心，不断提升产品品质' },
    { title: '内容为王', description: '精选优质内容，满足不同用户的观影需求' },
    { title: '技术创新', description: '持续投入技术研发，保证高清不缓冲的播放体验' },
    { title: '合作共赢', description: '与版权方建立良好合作关系，共建健康行业生态' },
  ],
  milestones: [
    { year: '2020', event: '糖心视频正式上线，开启免费观影新时代' },
    { year: '2021', event: '月活跃用户突破1000万，内容库超过1万部' },
    { year: '2022', event: '推出4K高清专区，技术全面升级' },
    { year: '2023', event: '月活跃用户突破3000万，成为行业领先平台' },
    { year: '2024', event: '内容库突破8万部，覆盖全球优质影视资源' },
    { year: '2025', event: '月活跃用户突破5000万，AI智能推荐系统上线' },
    { year: '2026', event: '全面升级播放技术，实现真正零缓冲观影体验' },
  ],
  contact: {
    email: 'contact@tangxin.com',
    phone: '400-888-9999',
    address: '北京市朝阳区建国路88号糖心大厦',
    wechat: 'tangxinshipin',
    weibo: '@糖心视频官方',
  },
  testimonials: [
    {
      name: '王女士',
      role: '资深剧迷',
      content: '糖心视频真的太棒了！资源丰富，更新快，画质高清，最关键的是完全不卡顿。自从用了糖心视频，我就没换过别的平台。',
      rating: 5,
    },
    {
      name: '李先生',
      role: '电影爱好者',
      content: '作为一个电影迷，糖心视频的片库真的让我惊喜。很多冷门好片都能找到，而且都是高清版本，观影体验非常棒！',
      rating: 5,
    },
    {
      name: '张同学',
      role: '大学生',
      content: '学生党最爱的免费追剧平台！不用会员就能看高清，宿舍四个人都用糖心视频，强烈推荐给所有同学。',
      rating: 5,
    },
    {
      name: '陈老师',
      role: '纪录片爱好者',
      content: '糖心视频的纪录片专区做得非常好，BBC、国家地理的经典纪录片都有，画质清晰，字幕翻译也很专业。',
      rating: 4,
    },
  ],
};